/** UI copy for the sign-in screens. Shared labels (Cancel, Email…) live in `COMMON_TEXT`. */
export const AUTH_TEXT = {
  chooseYear: {
    title: 'Choose the calendar year',
    welcome: (firstName?: string) =>
      firstName ? `Welcome ${firstName} on Compliance Desk` : 'Welcome on Compliance Desk',
    continue: (year: number) => `Continue with ${year}`,
  },
  login: {
    title: 'SHDA CPA LLC Compliance Desk Sign In',
    twoStepTitle: 'Two-step sign-in',
    passwordRequired: 'Password is required',
    forgotPassword: 'Forgot password?',
    submit: 'Sign in',
  },
  google: {
    or: 'or',
    signIn: 'Sign in with Google',
    agreePrefix: 'By continuing with Google, you agree to the ',
    agreeJoin: ' and acknowledge the ',
    agreeSuffix: '.',
  },
  twoStep: {
    enterRecoveryCode: 'Enter one of your recovery codes.',
    enterAppCode: 'Enter the 6-digit code.',
    recoveryHint:
      'Enter one of the recovery codes you saved when you turned on two-step sign-in. Each works once.',
    appHint: 'Open your authenticator app and enter the 6-digit code for Compliance Desk.',
    recoveryCodeLabel: 'Recovery code',
    appCodeLabel: 'Authentication code',
    recoveryPlaceholder: 'xxxx-xxxx',
    appPlaceholder: '000000',
    useApp: 'Use the authenticator app',
    useRecovery: 'Use a recovery code',
  },
  forgot: {
    title: 'Reset your password',
    submit: 'Send reset link',
  },
  reset: {
    title: 'Choose a new password',
    inviteTitle: 'Welcome — choose your password',
    expiredTitle: 'Link expired',
    expiredMessage: 'This link has expired or was already used.',
    requestNewLink: 'Request a new link',
    savedTitle: 'Password saved',
    savedMessage: 'Your password is set. Sign in with it now.',
    goToSignIn: 'Go to sign in',
  },
  change: {
    forcedTitle: 'Set a new password',
    changeTitle: 'Change password',
    setTitle: 'Set a password',
    currentPasswordRequired: 'Current password is required',
    temporaryPassword: 'Temporary password',
    currentPassword: 'Current password',
    success: 'Password changed. Other devices were signed out.',
    signOutInstead: 'Sign out instead',
  },
  password: {
    newPassword: 'New password',
    repeatNewPassword: 'Repeat new password',
    save: 'Save password',
  },
  backToSignIn: 'Back to sign in',
  checkingSession: 'Checking your session',
  termsLink: 'Terms and Conditions',
  privacyLink: 'Privacy Policy',
  forbidden: {
    title: 'No access',
    message: "You don't have access to this page. An administrator can grant it in User Management.",
  },
} as const;
